import axios from 'axios';
import { API_URL, getAuthConfig } from './api';

const _err = (e) => {
    if (e.response) console.error('DateTreat API error:', e.response.status, e.response.data);
    else console.error('DateTreat API error:', e.message);
};

export const APIDateTreatStatus = async (token) => {
    try {
        const r = await axios.get(`${API_URL}/api/date-treat/status/`, getAuthConfig(token));
        return r.data; // { success, offer, eligible, reason, treat }
    } catch (e) { _err(e); throw e; }
};

export const APIDateTreatMy = async (token) => {
    try {
        const r = await axios.get(`${API_URL}/api/date-treat/my/`, getAuthConfig(token));
        return r.data;
    } catch (e) { _err(e); throw e; }
};

export const APIDateTreatClaim = async (token, placeId) => {
    try {
        const r = await axios.post(`${API_URL}/api/date-treat/claim/`,
            { place_id: placeId }, getAuthConfig(token));
        return r.data; // { success, treat }
    } catch (e) { _err(e); throw e; }
};

// -------- Публичный каталог мест --------
export const APIPlacesCities = async (token) => {
    try {
        const r = await axios.get(`${API_URL}/api/places/cities/`, getAuthConfig(token));
        return r.data; // { success, items: [{id, name, region}] }
    } catch (e) { _err(e); throw e; }
};

export const APIPlacesCategories = async (token, cityId) => {
    try {
        const q = cityId ? `?city_id=${cityId}` : '';
        const r = await axios.get(`${API_URL}/api/places/categories/${q}`, getAuthConfig(token));
        return r.data; // { success, items: [{id, name, slug, icon}] }
    } catch (e) { _err(e); throw e; }
};

export const APIPlaces = async (token, { cityId, categoryId, search } = {}) => {
    try {
        const p = new URLSearchParams();
        if (cityId) p.set('city_id', cityId);
        if (categoryId) p.set('category_id', categoryId);
        if (search) p.set('search', search);
        const r = await axios.get(`${API_URL}/api/places/?${p.toString()}`, getAuthConfig(token));
        return r.data; // { success, items: [place cards] }
    } catch (e) { _err(e); throw e; }
};